module.exports = __webpack_public_path__ + "static/media/entrepreneurs-hero.376e1221.webp";